export const WEB_GUEST_CONTROL_GET = "WEB_GUEST_CONTROL_GET";
export const WEB_GUEST_CONTROL_SET = "WEB_GUEST_CONTROL_SET";
export const WEB_GUEST_GUEST_DISCONNECTED = "WEB_GUEST_GUEST_DISCONNECTED";
export const WEB_GUEST_UNSUPPORTED_COMMAND = "WEB_GUEST_UNSUPPORTED_COMMAND";
